import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';

import Button from './Button';
import ClosePopUpButton from './ClosePopUpButton';
import { Form, Formik } from 'formik';

const StyledDialogContent = styled(DialogContent)({
  display: 'flex',
  flexDirection: 'column',
});

const DialogForm = (props) => {
  const { content, dialogError, handleCancel, onSubmit, disabled, initialValues } = props;
  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({ isSubmitting, dirty, values, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <StyledDialogContent>
            {content(values)}
            {dialogError && (
              <Typography color="error">
                {dialogError}
              </Typography>
            )}
          </StyledDialogContent>
          <DialogActions className="justify-center">
            <Button
              color="primary"
              onClick={handleSubmit}
              type="submit"
              label="Wyślij"
              disabled={isSubmitting || !dirty || disabled} />
          </DialogActions>
        </Form>
      )}
    </Formik>
  );
};

class SpecialDialogForm extends React.Component {
  static propTypes = {
    formContent: PropTypes.node.isRequired,
    initialValues: PropTypes.object,
    open: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    DialogProps: PropTypes.object,
    disabled: PropTypes.bool,
  };

  render() {
    const { formContent, initialValues, open, title, onCancel, error, DialogProps, ...rest } = this.props;

    return (
      <Dialog
        {...DialogProps}
        open={open}
        onClose={onCancel}
      >
        {(onCancel || title) && (
          <DialogTitle className="center">
            {title}
            {!!onCancel && <ClosePopUpButton onClick={onCancel} />}
          </DialogTitle>
        )}

        <DialogForm
          {...rest}
          initialValues={initialValues}
          dialogError={error}
          handleCancel={onCancel}
          content={formContent}
        />
      </Dialog>
    );
  }
}

export default SpecialDialogForm;
